export const PROPERTY_TYPE_OPTIONS = [
	{ label: "Rent Residential", value: "RentResident" },
	{ label: "Rent Commercial", value: "RentBog" },
	{ label: "Rent Other", value: "RentOther" },
	{ label: "Rent Parking", value: "RentPark" },
	{ label: "Buy Residential", value: "BuyResident" },
	{ label: "Buy Commercial", value: "BuyBog" },
	{ label: "Buy Other", value: "BuyOther" },
	{ label: "Buy Parking", value: "BuyPark" },
];

export type PropertyFilters = {
	area?: string[];
	location?: string[];
	ids?: string[];
};
